export { default, hasTextPassages, PassagePager, resolvedEvidence, usePagedIndex } from './cited-passages';
